export var getSearchResultsAnnounce = function (numResults, customAria) {
    if (customAria) {
        return customAria(numResults);
    }
    else if (numResults === 1) {
        return 'One result found';
    }
    else if (numResults === 0) {
        return 'No results found';
    }
    else {
        return "Top " + numResults + " results found";
    }
};
//# sourceMappingURL=GlobalSearch.utils.js.map